<script>
  import { slide } from 'svelte/transition'
  import { _ } from './services/i18n'
</script>

<section class="about" id="about">
  <div class="img-container">
    <img src="../assets/profila.jpg" alt="" class="about-image" />
  </div>
  <article class="about-text">
    <p>
      {$_('about.desc')}
    </p>
  </article>
</section>

<style>
  .about {
    padding: 4rem 2rem;
    background-color: var(--mainWhite);
    min-height: 100vh;
    display: flex;
    align-items: center;
    gap: 2rem;
    padding-top: 6rem;
  }
  .img-container {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-basis: 50%;
  }
  .about-image {
    width: 350px;
    max-width: 100%;
  }
  .about-text {
    flex-basis: 40%;
  }
  .about-text p {
    color: rgb(20, 24, 36);
    font-size: 1.2rem;
    font-weight: 500;
    width: 80%;
  }
  @media (max-width: 898px) {
    .about {
      height: auto;
    }
    .about-text p {
      width: 100%;
    }
  }
  @media (max-width: 768px) {
    .about {
      flex-direction: column-reverse;
      gap: 3rem;
      padding: 4rem 1rem;
      padding-top: 6rem;
    }
    .img-container {
      justify-content: center;
    }
    .about-image {
      width: 80%;
    }
    h2 {
      text-align: center;
    }
    p {
      text-align: center;
    }
  }
  @media (max-width: 500px) {
    .about-image {
      width: 300px;
    }
    .about-text p {
      width: 100%;
    }
  }
</style>
